import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { ReportVarsWidget as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;
require('../sass-main/pdc-widget-report-vars.sass');

export class ReportVarsWidget extends WidgetBase {
    public static _name: string = 'Report Variables';
    public static group: string = 'Misc.';
    public static moduleName: string = 'pdc-widget-report-vars';
    public static namespace: string = 'business-intelligence';
    public static icon: string = 'time';

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-report-vars'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(ReportVarsWidget);
